import { render, staticRenderFns } from "./MenuHeader.vue?vue&type=template&id=04433306&scoped=true"
import script from "./MenuHeader.vue?vue&type=script&lang=js"
export * from "./MenuHeader.vue?vue&type=script&lang=js"
import style0 from "./MenuHeader.vue?vue&type=style&index=0&id=04433306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04433306",
  null
  
)

export default component.exports